import {
    SAVE_PAYMENT_REQUEST_DATA,
    CLEAR_STATE,
} from '../actions/ComponentCallsActions'

const initialState = {
    customerData: {
        UIConfig: {
            LogoURI: 'https://www.vendortopay.com/images/defaultlogo.png',
            LogoPosition: 'Center',
            BackgroundColor: '#bf4bcc',
            ButtonBackgroundColor: '#4b6bcc',
            ButtonTextColor: '#ffffff',
            BackgroundImage:
                'https://www.vendortopay.com/images/DefaultGateway2.png',
            ShowBackgroundImage: true,
        },
        PaymentRequest: {
            TrackID: '',
            OrderNo: '',
            Remarks: '',
            Amount: '',
            RedirectUrl: '',
        },
        PaymentOptions: {
            HDFCSeamless: false,
            HDFCOff: false,
            ICICIOn: false,
            ICICIOff: false,
            NetB: false,
            VTAP: false,
            PineLab: false,
        },
    },
}

const ComponentCallsReducer = function (state = initialState, action) {
    switch (action.type) {
        case SAVE_PAYMENT_REQUEST_DATA: {
            return {
                ...state,
                customerData: { ...action.payload },
            }
        }
        case CLEAR_STATE: {
            return {
                ...initialState,
            }
        }
        default: {
            return {
                ...state,
            }
        }
    }
}

export default ComponentCallsReducer
